var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow","d":"M5.5,7,0,1.324,1.283,0,5.5,4.351,9.717,0,11,1.324Z","transform":"translate(0.696 0.719)","fill":"#254c5b","stroke":"#254c5b","strokeWidth":"1"}));
}

DownArrow.defaultProps = {"width":"12.393","height":"8.437","viewBox":"0 0 12.393 8.437"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
